import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private matSnackBar: MatSnackBar) {}

  private configurationSuccess: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'bottom',
    panelClass: ['snackbar-success'],
  };

  private configurationError: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'bottom',
    panelClass: ['snackbar-warning'],
  };

  private getErrorMessage(error: HttpErrorResponse): string {
    const errorMessages = {
      400: 'The request is invalid. Please check the data and try again.',
      401: 'Unauthorized. Please log in to continue.',
      404: 'The requested resource was not found.',
      500: 'Server error. Please try again later.',
      502: 'Gateway server error. Please try again later.',
      503: 'The service is temporarily unavailable.',
      default: '',
    };

    return (
      errorMessages[error.status as keyof typeof errorMessages] ||
      errorMessages['default']
    );
  }

  errorNotification(error: HttpErrorResponse): void {
    const message = this.getErrorMessage(error);

    if (message) {
      this.matSnackBar.open(message, '', this.configurationError);
    }
  }

  setSuccessNotification(message: string) {
    return this.matSnackBar.open(message, '', this.configurationSuccess);
  }

  setErrorMessage(message: string) {
    return this.matSnackBar.open(message, '', this.configurationError);
  }
}
